import { createAction } from '@reduxjs/toolkit'
import { User } from '../models/Organization'
import { AccessPolicy } from '../models/AccessControl'

export const setAuthenticated = createAction<boolean>('auth/setAuthenticated')
export const addUser = createAction<User>('auth/addUser')
export const addUsers = createAction<User[]>('auth/addUsers')
export const setUserPolicies = createAction<AccessPolicy[]>(
  'auth/setUserPolicies',
)
